// extracted by mini-css-extract-plugin
export default {"Content":"EditListContentFullView_Content__jI2DV"};